import { createFileRoute } from '@tanstack/react-router';
import { WhatsOnAppointmentPage } from '../../../../features/whats-on/routes/WhatsOnAppointmentPage';

export const Route = createFileRoute('/whats-on/$token/appointments/$appointmentId')({
    component: WhatsOnAppointmentPage,
    params: {
        parse: (params) => {
            return { appointmentId: parseInt(params.appointmentId, 10), token: params.token };
        },
        stringify: (value) => {
            return { appointmentId: value.appointmentId.toString(), token: value.token };
        },
    },
});
